import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { VerificationCodeInput } from '@app/components/common/inputs/VerificationCodeInput/VerificationCodeInput';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { doLogin, doVerifySecurityCode } from '@app/store/slices/authSlice';
import { notificationController } from '@app/controllers/notificationController';
import VerifyEmailImage from '@app/assets/images/verify-email.webp';
import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
import * as S from './OTPCodeForm.styles';
import { BaseImage } from '@app/components/common/BaseImage/BaseImage';
import { BaseSpin } from '@app/components/common/BaseSpin/BaseSpin';
import { readUser } from '@app/services/localStorage.service';

interface OTPCodeFormProps {
  onBack?: () => void;
  onFinish?: () => void;
  values?: any
  location?: any
}

export const OTPCodeForm: React.FC<OTPCodeFormProps> = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  console.log({ props });
  const navigateBack = useCallback(() => navigate(-1), [navigate]);
  const navigateForward = useCallback(() => navigate(location && location.search && location.search.includes('register') ? '/auth/login' : '/auth/new-password'), [navigate]);
  const onBack = props.onBack;
  const onFinish = props.onFinish;
  const [securityCode, setSecurityCode] = useState('');
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (securityCode.length === 6) {
      setLoading(true);
      dispatch(doVerifySecurityCode({ email: props.values || localStorage.getItem('emailForPass'), otp: securityCode }))
        .unwrap()
        .then((resp) => {

          if (resp) {
            let message=location && location.search && location.search.includes('register') ? "Your account has been verified, use your new credentials to log in" : "Your account's password has been changed', use your new credentials to log in";
            notificationController.success({ message: message });
            let path = location && location.search && location.search.includes('register') ? '/auth/login' : '/auth/new-password';

            navigate(path)
          }


        })
        .catch((err) => {
          notificationController.error({ message: err.message });
          setLoading(false);
        });


      // dispatch(doVerifySecurityCode({ code: securityCode }))
      //   .unwrap()
      //   .then(onFinish || navigateForward)
      //   .catch((err) => {
      //     notificationController.error({ message: err.message });
      //     setLoading(false);
      //   });
    }
  }, [securityCode, navigateForward, onFinish, dispatch]);

  return (
    <Auth.FormWrapper>
      <BaseForm layout="vertical" requiredMark="optional">
        <Auth.BackWrapper onClick={onBack || navigateBack}>
          <Auth.BackIcon />
          {t('common.back')}
        </Auth.BackWrapper>
        <S.ContentWrapper>
          <S.ImageWrapper>
            <BaseImage src={VerifyEmailImage} alt="Not found" preview={false} />
          </S.ImageWrapper>
          <Auth.FormTitle>{t('securityCodeForm.title')}</Auth.FormTitle>
          <S.VerifyEmailDescription>{t('common.verifCodeSent')}</S.VerifyEmailDescription>
          {isLoading ? <BaseSpin /> : <VerificationCodeInput autoFocus onChange={setSecurityCode} />}
          <Link to="/" target="_blank">
            <S.NoCodeText>{t('securityCodeForm.noCode')}</S.NoCodeText>
          </Link>
        </S.ContentWrapper>
      </BaseForm>
    </Auth.FormWrapper>
  );
};
